import * as z from 'zod';

import { MemberRole } from '@/services/internal-api/accounts/types/accounts-api-service-enums';

export const invitationSchema = z.object({
  email: z
    .email({ error: 'Invalid email address.' })
    .min(1, { error: 'Email is required.' }),
  role: z.enum(MemberRole, { error: 'Role is required.' }),
});

export const inviteFormSchema = z.object({
  invitations: z
    .array(invitationSchema)
    .min(1, { message: 'At least one invitation is required.' })
    .max(10, { message: 'Maximum 10 invitations can be sent at once.' }),
  message: z.string().optional(),
});
